// Product help pages — public, NOT parish-scoped, unlike
// lib/parishHelp.ts (which owns /:parish/help). One markdown file per
// page under content/help/, compiled into the bundle the same way the
// parish help center is. No image pipeline yet — add one the way
// parishHelp.ts does if a page ever needs screenshots.

import { marked } from "marked";

const PAGES = import.meta.glob<string>("../../../content/help/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

export interface ProductHelpPage {
  title: string;
  html: string;
}

const CACHE = new Map<string, ProductHelpPage | null>();

export function loadProductHelp(slug: string): ProductHelpPage | null {
  if (CACHE.has(slug)) return CACHE.get(slug) ?? null;
  let found: ProductHelpPage | null = null;
  for (const [key, raw] of Object.entries(PAGES)) {
    if (!key.endsWith(`/help/${slug}.md`)) continue;
    const match = raw.match(/^---\n([\s\S]*?)\n---\n?([\s\S]*)$/);
    let title = slug;
    let body = raw;
    if (match) {
      body = match[2];
      const t = match[1].match(/^title:\s*(.+)$/m);
      if (t) title = t[1].trim().replace(/^["']|["']$/g, "");
    }
    found = {
      title,
      html: marked.parse(body, { async: false, gfm: true, breaks: false }) as string,
    };
    break;
  }
  CACHE.set(slug, found);
  return found;
}
